import type { QualitySlide } from "@/types"

export const qualitySlides: QualitySlide[] = [
  {
    id: "1",
    src: "https://images.unsplash.com/photo-1490750967868-88aa4486c946?auto=format&fit=crop&w=900&q=80",
    alt: "Yellow flowers in a field",
    category: "Started in 2017",
    title: "FLora Delight",
    description: "There's always something happening at Flower Exchange!\nNew products",
    location: "Dubai, United Arab Emirates",
  },
  {
    id: "2",
    src: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=900&q=80",
    alt: "Garden bench among greenery",
    category: "Started in 2017",
    title: "Uhuru",
    description: "There's always something happening at Flower Exchange!\nNew products",
    location: "Nairobi, Kenya",
  },
  {
    id: "3",
    src: "https://images.unsplash.com/photo-1518994603110-1912b3272afd?auto=format&fit=crop&w=900&q=80",
    alt: "Greenhouse interior",
    category: "Started in 2017",
    title: "Green House",
    description: "There's always something happening at Flower Exchange!\nNew products",
    location: "Amsterdam, Netherlands",
  },
]
